// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-settings-form--layout > form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; }\n\n.certificate-settings-form--layout .certificate-settings-form--actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  justify-content: flex-end; }\n", ""]);
// Exports
module.exports = exports;
